module.exports = "pegasus/assets/vr-logo.png";